import { render, staticRenderFns } from "./linkTask.vue?vue&type=template&id=663f7486&"
import script from "./linkTask.vue?vue&type=script&lang=js&"
export * from "./linkTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports